<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.877 8.246h11.457c.436 0 .79-.336.79-.75s-.354-.75-.79-.75H7.877c-.436 0-.79.336-.79.75s.354.75.79.75ZM4.877 8.496a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19.334 11.25H7.877c-.436 0-.79.336-.79.75s.354.75.79.75h11.457c.436 0 .79-.336.79-.75s-.354-.75-.79-.75ZM4.877 12.996a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19.334 15.75H7.877c-.436 0-.79.336-.79.75s.354.75.79.75h11.457c.436 0 .79-.336.79-.75s-.354-.75-.79-.75ZM4.877 17.504a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      fill="currentColor"
    />
  </svg>
</template>
